import { makeRequest } from './https';
import { LoginRequest, RegisterRequest, ForgotPasswordRequest, ResetPasswordRequest } from '../types/auth.type';

export const login = (data: LoginRequest) =>
  makeRequest({ url: '/auth/login', method: 'post', data });

export const register = (data: RegisterRequest) =>
  makeRequest({ url: '/auth/register', method: 'post', data });

export const refreshTokenService = (refreshToken: string) =>
  makeRequest({
    url: '/auth/refresh',
    method: 'post',
    data: { refresh_token: refreshToken },
    isAuthRequest: true,
  });

export const forgotPassword = (data: ForgotPasswordRequest) =>
  makeRequest({ url: '/auth/forgot-password', method: 'post', data });

export const resetPassword = (data: ResetPasswordRequest) =>
  makeRequest({ url: '/auth/reset-password', method: 'post', data });

export const getCurrentUser = () =>
  makeRequest({ url: '/auth/me', method: 'get' });
